//@flow
//Action Type Registered
export const URANUS_INV_SUBMIT_SUCCESS='URANUS_INV_SUBMIT_SUCCESS'
export const URANUS_INV_SUBMIT_ERROR='URANUS_INV_SUBMIT_ERROR'
export const URANUS_INV_SUBMITTED_COMPLETED='URANUS_INV_SUBMITTED_COMPLETED'
export const URANUS_EDIT_VERIFY_FORM_DATA_SUCCESS='URANUS_EDIT_VERIFY_FORM_DATA_SUCCESS'
export const URANUS_EDIT_VERIFY_FORM_DATA_ERROR='URANUS_EDIT_VERIFY_FORM_DATA_ERROR'
export const URANUS_UPDATE_FORM_ERROR='URANUS_UPDATE_FORM_ERROR'
export const REFRESH_URANUS_VENDORS_SUCCESS='REFRESH_URANUS_VENDORS_SUCCESS'
export const REFRESH_URANUS_VENDORS_ERROR='REFRESH_URANUS_VENDORS_ERROR'



// WEBPACK FOOTER //
// ./src/redux/uranus/actionTypes.js